import { Action } from '@ngrx/store';
import { Industry } from 'src/app/shared/types/industry.types';

export const INDUSTRIES_LOAD = '[INDUSTRY] Load industries';
export const INDUSTRIES_LOAD_SUCCESS = '[INDUSTRY] Load industries successful';
export const INDUSTRIES_LOAD_ERROR = '[INDUSTRY] Load industries failed';

export class IndustriesLoad implements Action {
  readonly type = INDUSTRIES_LOAD;
}

export class IndustriesLoadSuccess implements Action {
  readonly type = INDUSTRIES_LOAD_SUCCESS;
  constructor(public payload: Industry[]) {}
}

export class IndustriesLoadError implements Action {
  readonly type = INDUSTRIES_LOAD_ERROR;
}

export type Actions = IndustriesLoad | IndustriesLoadSuccess | IndustriesLoadError;
